// CHAT-UX-01 (doc 29 §4.1) -- how long the student waited for a tutor reply,
// as text: from the Send to the moment the whole reply was visible. Pure
// formatting, no store and no i18n instance: the caller owns the copy.
//
//   under one minute   seconds with one decimal   «۸٫۳» / "8.3"
//   from one minute    minutes and seconds        «۱:۱۲» / "1:12"
//
// Digits and the decimal separator follow the locale through `Intl`, like the
// rest of the Student pages (utils/reportsFormat.js).

const SECONDS = { minimumFractionDigits: 1, maximumFractionDigits: 1 }
const WHOLE = { useGrouping: false, maximumFractionDigits: 0 }
const TWO_DIGITS = { ...WHOLE, minimumIntegerDigits: 2 }

/**
 * @param {*} ms the measured wait in milliseconds
 * @param {string} locale a BCP 47 tag (`fa-IR`, `en-US`)
 * @returns {{kind:'seconds'|'clock', value:string}|null} `null` for anything
 *   that is not a real, non-negative duration -- never a made-up zero
 */
export function formatReplyDuration(ms, locale) {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms < 0) return null
  const tenths = Math.round(ms / 100)
  if (tenths < 600) {
    return {
      kind: 'seconds',
      value: (tenths / 10).toLocaleString(locale, SECONDS),
    }
  }
  const whole = Math.round(ms / 1000)
  const minutes = Math.floor(whole / 60).toLocaleString(locale, WHOLE)
  const seconds = (whole % 60).toLocaleString(locale, TWO_DIGITS)
  return { kind: 'clock', value: `${minutes}:${seconds}` }
}

export default formatReplyDuration
